'use client';

import { AppImageData } from '@components/appImage';
import { Swiper, SwiperSlide } from 'swiper/react';

import { servicesCards } from '../markupConfig';

import { SmallCard } from '@/shared/components/smallCard';

export const ServicesSlider = ({
  translations,
  cards,
}: {
  translations: Record<string, string>;
  /** Карточки с imageData вместо imageSrc — данные готовит серверный родитель через `getAppImageData` (96x96) */
  cards: (Omit<(typeof servicesCards)[number], 'imageSrc'> & {
    imageData: AppImageData;
  })[];
}) => {
  return (
    <Swiper spaceBetween={12} slidesPerView="auto" className="!px-[20px]">
      {cards.map((card, index) => (
        <SwiperSlide key={index}>
          <SmallCard
            description={translations[card.title]}
            descriptionId={translations[card.title]}
            subDescription={translations[card.description]}
            imageData={card.imageData}
            alt={card.alt}
            customClassNames={{
              main: 'w-full !min-h-[320px]',
              content:
                index === 0
                  ? '!text-[20px] !leading-[24px] font-medium max-w-[270px]'
                  : '!text-[20px] !leading-[24px] font-medium',
              subDescription: '!text-[16px] !leading-[24px] font-normal',
              img: 'w-[96px] h-[96px] object-cover',
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
